import React from "react";

import { cx } from "~/tools/class-variance";
import type { Time } from "~/tools/date-time/time";
import { timeToPx } from "~/tools/time-to-px";

import { useTimelineContext, useTimelineRange } from "../_context";

import { TimelineControlElement } from "./TimelineControlElement";

export interface TimelineMarkerProps {
	timestamp: Time;
	theme?: "default" | "purple" | "red" | "graphite";
	dashed?: boolean;
}

export const TimelineMarker: React.FC<React.PropsWithChildren<TimelineMarkerProps>> = ({
	timestamp,
	dashed,
	theme = "default",
	children,
}) => {
	const { stageWidth } = useTimelineContext();
	const [timelineStart, timelineEnd] = useTimelineRange();
	const px = timeToPx({
		time: timestamp,
		width: stageWidth,
		interval: { start: timelineStart, end: timelineEnd },
	});

	if (px < 0 || px > stageWidth) {
		return null;
	}

	return (
		<TimelineControlElement
			className={cx(
				"top-5 bottom-1 border-0 border-l",
				dashed ? "border-dashed" : "border-solid",
				theme === "default" && "border-graphite-500",
				theme === "purple" && "border-purple-500",
				theme === "red" && "border-red-500",
				theme === "graphite" && "border-graphite-300",
			)}
			x={px}
		>
			{children}
		</TimelineControlElement>
	);
};
